import BaseComponentController from '../../../../components/base-component.controller';

class ClosePersonalRelationshipController extends BaseComponentController {
    constructor(_, componentRegistryService, $q) {
        super(_, componentRegistryService, $q);
        this.vm = {
            errors:[]
        };
        this.individualTypeOptions = [
            {
                id: "Curtin",
                description: "Curtin Staff"
            },
            {
                id: "External",
                description: "Non-Curtin Entity"
            }
        ];
    }

    init() {
        
        if (this._.isEmpty(this.model)) {
            this.vm = {

                errors:[]
            };
            this.model = {
                fullName: null,
                position: null,
                division: null,
                selectedOption: null
            };
        } else {
            this.vm = {
                errors:[]
            };
            // initialize model for rendering fields.
            this.model.selectedOption = this.individualTypeOptions.filter(option => option.id === this.model.selectedOptionId)[0];
            this.model.fullName = this.model.fullName || null;
            this.model.position = this.model.position || null;
            this.model.division = this.model.division || null;
        }
    }

    validate() {
        if (this.readonly) {
            return true;
        }

        if (this._.isEmpty(this.model.selectedOption)) {
            this.vm.errors= [`Please select a person type`];
        } else {
            this.vm.errors = [];
        }
        return this.vm.errors.length === 0;
    }

    validateAsync() {
        return this.getPromise(this.validate());
    }

    individualOptionSelected() {
        this.vm = {
            errors:[]
        };
    }
}

ClosePersonalRelationshipController.$inject = ['_', 'componentRegistryService', '$q'];

let closePersonalRelationshipComponent = {
    controller: ClosePersonalRelationshipController,
    bindings: {
        readonly: '<',
        modelName:'@',
        onUserValidate: '&'
    },
    templateUrl:`app/disclose/conflictOfInterest/components/close-personal-relationship/close-personal-relationship.html`
};

export default closePersonalRelationshipComponent;


// WEBPACK FOOTER //
// ./app/disclose/conflictOfInterest/components/close-personal-relationship/close-personal-relationship.component.js